import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { isEqual } from 'lodash';
import { injectIntl } from 'react-intl';

import requestStatuses from 'modules/common/constants/requestsStatuses';
import {
  isErrorCode,
  checkErrorStatus,
  checkImmediateErrorStatus,
  checkSyncedErrorStatus,
} from '../checkError';
import { FormFieldError, Label } from '../../index';

import { Input } from '../index';
import theme from './PhoneInput.scss';

const propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    value: PropTypes.any,
    name: PropTypes.string,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    pristine: PropTypes.bool,
    submitFailed: PropTypes.bool,
  }).isRequired,
  errorMessagesMap: PropTypes.object,
  label: PropTypes.object,
  phonePlaceholder: PropTypes.object,
  codePlaceholder: PropTypes.object,
  rootClassName: PropTypes.string,
  immediateErrors: PropTypes.bool,
  syncErrors: PropTypes.bool,
  disabled: PropTypes.bool,
};

const defaultProps = {
  errorMessagesMap: {},
  label: null,
  phonePlaceholder: { id: 'MyAccount.Details.Edit.MobilePhoneNumber.Placeholder', defaultMessage: '** Type user’s phone' },
  codePlaceholder: { id: 'MyAccount.Details.Edit.MobilePhoneNumber.Code.Placeholder', defaultMessage: '** Type code' },
  rootClassName: '',
  immediateErrors: false,
  syncErrors: false,
  disabled: false,
};

class PhoneNumberAndCountryCode extends Component {

  shouldComponentUpdate(nextProps) {
    return !isEqual(this.props.input, nextProps.input)
      || !isEqual(this.props.meta, nextProps.meta)
      || this.props.disabled !== nextProps.disabled;
  }

  onFocus = (e, field = '') => {
    e.phoneInputField = field;
    this.props.input.onFocus(e);
    this.props.input.onChange(this.props.input.value);
    this.props.input.onBlur();
  };

  onBlur = () => this.props.input.onBlur();

  render() {
    const {
      intl,
      input: {
        name,
        id,
      },
      meta: { error },
      errorMessagesMap,
      label,
      labelSuffix,
      disabled,
      codePlaceholder,
      phonePlaceholder,
      tooltipType,
      tooltipTestId,
      tooltipSize,
      rootClassName,
      immediateErrors,
      syncErrors,
      required,
    } = this.props;

    const errorMessage = !isErrorCode(error)
      ? { defaultMessage: error, id: 'default' }
      : error && errorMessagesMap[error];

    const errorState = immediateErrors
      ? checkImmediateErrorStatus(this.props.meta)
      : syncErrors
        ? checkSyncedErrorStatus(this.props.meta)
        : checkErrorStatus(this.props.meta);

    const errorStatus = errorState
      ? requestStatuses.failure
      : requestStatuses.default;

    return (
      <div className={ rootClassName }>
        <If condition={ label }>
          <Label
            label={ label }
            className={ theme.label }
            labelSuffix={ labelSuffix }
            htmlFor={ id || name }
          />
        </If>

        <div className={ theme.root } >
          <div className={ theme.code }>
            <Field
              ariaLabel={ intl.formatMessage({ id: 'General.PhoneCountryCode', defaultMessage: '** Country code' }) }
              component={ Input }
              required={ required }
              name={ `${ name }.countryCode` }
              testId={ name }
              validatePattern="^[0-9\b]+$"
              maxLength={ 6 }
              placeholder={ codePlaceholder }
              status={ errorStatus }
              disabled={ disabled }
              onFocus={ value => this.onFocus(value, 'countryCodeValue') }
              onBlur={ this.onBlur }
              inputMode="tel"
            />
          </div>

          <div className={ theme.number }>
            <Field
              ariaLabel={ intl.formatMessage({ id: 'General.PhoneNum', defaultMessage: '** Phone number' }) }
              component={ Input }
              required={ required }
              name={ `${ name }.phone` }
              testId={ name }
              validatePattern="^[0-9\b]+$"
              maxLength={ 12 }
              placeholder={ phonePlaceholder }
              status={ errorStatus }
              disabled={ disabled }
              onFocus={ this.onFocus }
              onBlur={ this.onBlur }
              inputMode="numeric"
            />
          </div>
        </div>

        <FormFieldError
          tooltipType={ tooltipType }
          testId={ tooltipTestId }
          tooltipMessage={ errorStatus === requestStatuses.failure ? errorMessage : null }
          tooltipSize={ tooltipSize }
        />
      </div>
    );
  }
}

PhoneNumberAndCountryCode.propTypes = propTypes;
PhoneNumberAndCountryCode.defaultProps = defaultProps;

export default injectIntl(PhoneNumberAndCountryCode);
